<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="./../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header style="min-height: 60vh">
        <template slot="header">Change Password</template>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <div :class="{ error: validation.hasError('oldPassword') }">
              <b-form-group label="Old Password">
                <b-form-input
                  v-model="oldPassword"
                  type="password"
                  id="oldPassword"
                  placeholder="●●●●●●●●"
                ></b-form-input>
                <template
                  slot="description"
                  v-if="validation.firstError('oldPassword')"
                >
                  <span style="color: red">{{
                    validation.firstError("oldPassword")
                  }}</span>
                </template>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <div :class="{ error: validation.hasError('newPassword') }">
              <b-form-group label="New Password">
                <b-form-input
                  v-model="newPassword"
                  type="password"
                  id="newPassword"
                  placeholder="●●●●●●●●"
                ></b-form-input>
                <template
                  slot="description"
                  v-if="validation.firstError('newPassword')"
                >
                  <span style="color: red">{{
                    validation.firstError("newPassword")
                  }}</span>
                </template>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <div :class="{ error: validation.hasError('confirmPassword') }">
              <b-form-group label="Confirm Password">
                <b-form-input
                  v-model="confirmPassword"
                  type="password"
                  id="confirmPassword"
                  placeholder="●●●●●●●●"
                ></b-form-input>
                <template
                  slot="description"
                  v-if="validation.firstError('confirmPassword')"
                >
                  <span style="color: red">{{
                    validation.firstError("confirmPassword")
                  }}</span>
                </template>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6" class="pb-2 text-center">
            <span style="font-size: 14px; font-weight: 500; color: red">{{
              msg
            }}</span>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <div class="px-2">
            <b-button
              variant="outline-primary"
              size="sm"
              @click.prevent="inputCheck"
              >Change Password</b-button
            >
          </div>
        </b-row>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      msg: null,
    };
  },
  validators: {
    oldPassword(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
    newPassword(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
    confirmPassword(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
  },
  methods: {
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.changePassword();
        } else {
          this.$notify({
            group: "appNotification",
            title: "Please Validate Input Fields",
            text: "",
            type: "error",
          });
          return;
        }
      });
    },
    changePassword() {
      this.appLoading = true;
      var data = {};
      data["ID"] = store.state.completeUserData.id;
      data["Password"] = this.oldPassword;
      data["Newpassword"] = this.newPassword;
      axios({
        method: "POST",
        url: "/shop/changePassword",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
  },
};
</script>